import { render } from "./App.vue?vue&type=template&id=2b6fe50c"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=2b6fe50c&lang=css"

import exportComponent from "C:\\Users\\abela\\Documents\\Projects\\SmartTile\\gympass-web-vue\\gympass-web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__